import { useCallback, useEffect, useRef, useState } from "react"
import { formatNumber } from "@lib/util"
import { Col, Input, Label, Row } from "reactstrap"

const IpWarmupForm = () => {
  // State
  const [result, setResult] = useState({
    days: [],
    total: 0,
    average: 0
  })
  const [isDatasetValid, setIsDatasetValid] = useState(true)
  // Refs
  const baseAmountInput = useRef(null)
  const percentInput = useRef(null)
  const numberOfDaysInput = useRef(null)

  // Functions
  const calculateAmounts = (amount, percent, numberOfDays) => {
    // calculate each day's amount after percent increase
    const days = [],
      dailyIncrease = [0]
    for (let i = 0; i < numberOfDays; i++) {
      days.push(amount)
      const increase = Math.round((amount * percent) / 100)
      dailyIncrease.push(increase)
      amount = amount + increase
    }
    // total amount and average amount
    const total = days.reduce((a, b) => a + b, 0)
    const average = (total / days.length).toFixed(2)
    return {
      days,
      dailyIncrease,
      total,
      average
    }
  }

  const calculateResults = useCallback(() => {
    const baseAmount = parseInt(baseAmountInput.current.value) || 3000
    const percent = parseInt(percentInput.current.value) || 15
    const numberOfDays = parseInt(numberOfDaysInput.current.value) || 7
    const amounts = calculateAmounts(baseAmount, percent, numberOfDays)
    setIsDatasetValid(baseAmount > 0 && percent > 0 && numberOfDays > 0 && amounts.days.length > 0)
    setResult(amounts)
  }, [])

  useEffect(() => {
    calculateResults()
  }, [calculateResults])

  return (
    <>
      <div>
        <h3>IP Warmup</h3>
        <p>Used by the marketing team to calculate the warmup time of a newly acquired IP address on Brevo.</p>
      </div>
      <div>
        <form id="frmIpWarmup" name="frmIpWarmup" onChange={calculateResults}>
          <Row>
            <Col className="mb-1" md="2" sm="12">
              <Label className="form-label" for="amount">
                Base amount
              </Label>
              <Input
                type="number"
                id="amount"
                name="amount"
                innerRef={baseAmountInput}
                defaultValue={3000}
                placeholder="3000"
                onKeyDown={calculateResults}
              />
            </Col>
            <Col className="mb-1" md="2" sm="12">
              <Label className="form-label" for="percent">
                Augmentation %
              </Label>
              <Input
                type="number"
                id="percent"
                name="percent"
                innerRef={percentInput}
                defaultValue={15}
                placeholder="15"
                onKeyDown={calculateResults}
              />
            </Col>
            <Col className="mb-1" md="2" sm="12">
              <Label className="form-label" for="numberOfDays">
                Number of days
              </Label>
              <Input
                type="number"
                id="numberOfDays"
                name="numberOfDays"
                innerRef={numberOfDaysInput}
                defaultValue={7}
                placeholder="7"
                onKeyDown={calculateResults}
              />
            </Col>
          </Row>
        </form>

        <Col className="mb-1" md="6" sm="12">
          <h4>Amount per day</h4>
          {isDatasetValid ? (
            <div>
              {result.days.map((day, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between pt-1 border-bottom-light"
                >
                  <span>Day {index + 1}</span>
                  <div className="d-flex gap-1">
                    <span className="text-muted">+{result.dailyIncrease[index]}</span>
                    <div style={{ minWidth: "8rem", textAlign: "right" }}>{day}</div>
                  </div>
                </div>
              ))}
              <div className="mt-1 border-bottom-primary border-2">
                <div className="d-flex justify-content-between">
                  <span>Average per day</span>
                  <span className="fs-4 text-muted">{formatNumber(result.average)}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <b>Total email sent</b>
                  <span className="fs-3">{formatNumber(result.total)}</span>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-danger">Please enter valid values for all fields.</p>
          )}
        </Col>
      </div>
    </>
  )
}

export default IpWarmupForm
